import { render, staticRenderFns } from "./realEstateDevelopmentDiagnosisResultDetail.vue?vue&type=template&id=d18fafb4&scoped=true"
import script from "./realEstateDevelopmentDiagnosisResultDetail.vue?vue&type=script&lang=js"
export * from "./realEstateDevelopmentDiagnosisResultDetail.vue?vue&type=script&lang=js"
import style0 from "./realEstateDevelopmentDiagnosisResultDetail.vue?vue&type=style&index=0&id=d18fafb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d18fafb4",
  null
  
)

export default component.exports